export const onboardingContent = {
  title: '要件品質チェックの使い方',
  sections: [
    {
      heading: 'この画面でわかること',
      image: '/images/help/requirements_quality/SS1.png',
      body: '成果物の作り込み量に対するリスク密度で品質を診断。炎上しやすい論点の指摘が確認できます。'
    },
    {
      heading: '指摘の見方',
      body: '重要度（Critical/Warning）と、金銭・法務・運用・信頼の4分類＋その他で整理されています。'
    },
    {
      heading: '対応の仕方',
      body: '各指摘を確認し、必要な対応を検討してください。'
    },
    {
      heading: '専門家に相談できます',
      body: 'システム開発は、こういった様々な視点でリスクを潰し設計を行います。不明な点があればご相談ください。'
    }
  ]
}
